import React from "react";

const statusLevelMap = {
  "pending for approval": 1,
  "in process": 2,
  processing: 3,
};

const currencyIcons = { INR: "₹", USD: "$", AED: "د.إ" };

const bgColors = ["bg-white", "bg-white", "bg-white"];
const iconColors = ["text-blue-600", "text-green-600", "text-orange-600"];
const badgeColors = ["bg-blue-500", "bg-green-500", "bg-orange-500"];

const CurrencyWidgets = ({ selectedLevel, dashboardData }) => {
  const currentYear = new Date().getFullYear();

  const isCurrentYear = (item) => {
    const date = new Date(item.updatedAt || item.createdAt);
    return date.getFullYear() === currentYear;
  };

  const getLevelCurrencyData = (level, data) => {
    if (!data) return {};
    const currencyTotals = {};

    data.forEach((pr) => {
      // 🚫 Skip last year PRs
      if (!isCurrentYear(pr)) return;

      const prStatus = pr.status?.toLowerCase()?.trim();
      const prLevel = statusLevelMap[prStatus];
      if (prLevel !== level) return;

      const currency = pr.body?.currency || "INR";
      const amount =
        parseFloat(pr.body?.approxCost?.replace(/[^0-9.-]+/g, "")) || 0;

      if (!currencyTotals[currency]) {
        currencyTotals[currency] = { totalAmount: 0, count: 0 };
      }

      currencyTotals[currency].totalAmount += amount;
      currencyTotals[currency].count += 1;
    });

    return currencyTotals;
  };

  const levelData = getLevelCurrencyData(selectedLevel, dashboardData);

  return (
    <div className="mb-3 grid grid-cols-1 sm:grid-cols-3 gap-3">
      {["INR", "USD", "AED"].map((currency, index) => {
        const data = levelData[currency] || { totalAmount: 0, count: 0 };

        const formattedAmount = data.totalAmount.toLocaleString("en-IN", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });

        return (
          <div
            key={currency}
            className={`rounded-lg p-3 sm:p-4 flex flex-col justify-between shadow-sm border border-transparent hover:border-blue-400 transition-all duration-300 ${bgColors[index % 3]}`}
          >
            <div className="flex items-center justify-between mb-2">
              <p className="text-lg font-semibold text-gray-800">
                {currency} {formattedAmount}
              </p>

              <span
                className={`text-3xl opacity-30 ${iconColors[index % 3]} select-none`}
              >
                {currencyIcons[currency] || currency}
              </span>
            </div>

            <div className="flex items-center justify-between mt-1">
              <span
                className={`text-[10px] ${badgeColors[index % 3]} px-1.5 py-0.5 rounded-full uppercase text-gray-100 font-medium`}
              >
                {data.count} PR(s)
              </span>

              <span className="bg-gray-200 text-gray-700 text-[10px] px-1.5 py-0.5 rounded-full font-medium">
                Level {selectedLevel} Pending
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CurrencyWidgets;
